export enum ControllerStatus {
  NOT_STARTED = 'NOT_STARTED',
  CHECKING = 'CHECKING',
  MANUAL_CHECK_REQUIRED = 'MANUAL_CHECK_REQUIRED',
  CHECK_SUCCESS = 'CHECK_SUCCESS',
  CHECK_REJECTED = 'CHECK_REJECTED',
  CHECK_ERROR = 'CHECK_ERROR',
  ESCALATING = 'ESCALATING',
  ESCALATION_REJECTED = 'ESCALATION_REJECTED',
  ESCALATION_ACCEPTED = 'ESCALATION_ACCEPTED',
  ESCALATION_ERROR = 'ESCALATION_ERROR',
  ACKNOWLEDGED_WITH_CHECK_SUCCESS = 'ACKNOWLEDGED_WITH_CHECK_SUCCESS',
  ACKNOWLEDGED_WITH_ESCALATION_REJECTED = 'ACKNOWLEDGED_WITH_ESCALATION_REJECTED',
  ACKNOWLEDGED_WITH_ESCALATION_ACCEPTED = 'ACKNOWLEDGED_WITH_ESCALATION_ACCEPTED',
}
